<script setup lang="ts">
    import { defineAsyncComponent } from 'vue';
    import TopBannerLeft from '../components/oferta/TopBannerLeft.vue'
    import FormarBloque from '../components/oferta/FormarBloqueNeo.vue';
    const ProgramaModelo = defineAsyncComponent(() => import('../components/oferta/ProgramaModelo.vue'));
const VerModelo = defineAsyncComponent(() => import('../components/oferta/VerModelo.vue'));
    const CalendarioOferta = defineAsyncComponent(() => import('../components/oferta/CalendarioOferta.vue')) ;
    const PoliticaIA = defineAsyncComponent(() => import('../components/oferta/PoliticaIA.vue'))
    // const DescargaFolleto = defineAsyncComponent(() => import('../components/oferta/DescargaFolleto.vue')) ; 
    // const LicExcelenciaAcadem = defineAsyncComponent(() => import('../components/oferta/LicExcelenciaAcadem.vue')) ; 
    // const CasosExito = defineAsyncComponent(() => import('../components/oferta/CasosExitoPrime.vue')); 
    
</script>

<template>
    <TopBannerLeft :img="'background-image: url(../../pagesImages/psico.jpg);'" :nivel="'Licenciatura en'" :carrera="'Psicolog&iacute;a'" :frase="'Una mente no puede entenderse sin la cultura'" :autor="'Lev Vygotsky'"/>
    <FormarBloque :img="'../../pagesImages/psicologia-ejecutivo.jpg'" alt="Licenciado en Psicología Universidad Humanitas" :link="'/requisitos-licenciatura'" :frase="'Hacer una diferencia en la vida de las personas, dedicando tiempo y energía para ayudarlas a superar sus adversidades'" :testo1="'Con base en una educación integral, formamos expertos en el estudio del comportamiento humano, con la capacidad de prevenir, diagnosticar e intervenir en problemáticas psicológicas en los ámbitos clínico, organizacional y educativo.'" :testo3="'Este programa está dirigido a personas interesadas en profundizar en el conocimiento de la mente, las emociones y el comportamiento humano. A quienes buscan comprender mejor a los demás y contribuir a su bienestar, con vocación de servicio y el deseo de marcar una diferencia positiva en la vida de las personas.'"/>
    <div class="flex items-center justify-center mb-12">
    </div>
    <ProgramaModelo :ejecutivo="true" :escolarizado="true" :virtual="true"/>
    <VerModelo esco="/pagesImages/Programas/Licenciatura/Escolarizado/lic-psicologia-escolarizado.webp"
    ejec="/pagesImages/Programas/Licenciatura/lic-psicologia-ejecutivo.webp"
    virt="/pagesImages/Programas/Licenciatura/lic-psicologia-ejecutivo.webp"
    :escoT="true"
    :ejecT="true"
    :virtT="true" />
    <CalendarioOferta nombre="Licenciatura en Psicología" :titulo="'Calendario de la licenciatura Escolarizada'" :subtitulo="'Conoce el programa de licenciatura que consolidará.'"
  :inicios="[true, true, false, false, true, true, false, false]"></CalendarioOferta>
    <CalendarioOferta nombre="Licenciatura en Psicología" :titulo="'Calendario de la licenciatura Ejecutiva'" :subtitulo="'Conoce el programa de licenciatura que consolidará.'"
  :inicios="[true, true, true, true, true, true, true, true]"></CalendarioOferta>
    <!-- <DescargaFolleto :esco="'/assets/lic-admin-esco.pdf'" :escoT="true" :ejec="'/assets/lic-admin-ejec.pdf'" :ejecT="true" :virt="'/assets/lic-admin-virt.pdf'" :virtT="true"/> -->
    <!-- <LicExcelenciaAcadem />
    <CasosExito /> -->
    <EgresadosHuma :types="'Licenciatura Psico'" class="mb-16" />
    
    <section class="flex items-center justify-center mb-16 w-full">
		<div class="lg:flex flex-col lg:px-0 px-8 items-center w-full max-w-4xl lg:max-w-[1200px] justify-start">
			<div class="flex flex-col justify-between w-full">
				<div class="lg:flex items-center justify-center">
                    <div class="lg:w-[50%] text-justify mb-8 lg:mb-0 lg:mr-12">
                        <h2>
                            <span class="block leading-none text-left text-[28px]" style="">Campus Humanitas que </span>
                            <span class="sr-only whitespace-nowrap">&nbsp;</span>
                            <span class="block text-hgold text-left font-serif mb-3 text-[42px]">cuentan con esta licenciatura</span>
                        </h2>
                        <div class="grid grid-cols-2 justify-center w-auto">
                            <ul class="list-disc pl-8 mb-4 ">
                                <li>Cancún</li>
                                <li>Chihuahua</li>
                                <li>Del Valle</li>
                                <li>Guadalajara</li>
                                <li>Presa Madín</li>
                                <li>Reyes</li>
                            </ul>
                            <ul class="list-disc mb-4">
                                <li>Tijuana</li>
                                <li>Virtual</li>
                                <li>Mérida</li>
                                <li>Querétaro</li>
                                <li>Santa Fe</li>
                            </ul>
                        </div>
                    </div>
                    <div class="flex items-center justify-center w-full lg:max-w-[520px]">
						<img src="/pagesImages/fachada-campus-madin.webp" alt="Imagen de fachada de Campus Madín" class="w-full lg:max-w-[520px]"/>
					</div>
                </div>
			</div>
		</div>
    </section>
    <section class="flex  justify-center mb-16 w-full">
		<div class="lg:flex flex-col lg:px-0 px-8 items-center w-full max-w-4xl lg:max-w-[1200px] justify-start">
			<div class="flex flex-col justify-between">
				<div class="lg:flex justify-center">
                    <div class="flex items-center justify-center w-full lg:max-w-[520px]">
						<img src="/pagesImages/licenciaturas-estructura.webp" alt="Estructura académica en Universidad Humanita" class="w-full lg:max-w-[520px]"/>
					</div>
                    <div class="lg:w-[50%] text-justify mt-8 lg:mt-0 lg:ml-12">
                        <h2>
                            <span class="block font-serif text-[42px] text-hgold text-left" style="">Estructura académica</span>
                            <span class="sr-only whitespace-nowrap">&nbsp;</span>
                            <span class="block text-xl text-left mb-3">(Bloques temáticos):</span>
                        </h2>
                        <ul class="list-disc pl-3 hyphens-auto">
                            <li><b>Bases biológicas y fisiológicas:</b> Procesos biológicos del ser humano I y II, Psicofarmacología.</li>
                            <li>Psicología del Desarrollo I y II.</li>
                            <li>Psicopatología y estructura de la personalidad.</li>
                            <li><b>Evaluación y diagnóstico psicológico:</b> Pruebas psicológicas, técnicas proyectivas, psicometría infantil, técnica de evaluación y diagnóstico familiar.</li>
                            <li><b>Intervención y terapia psicológica:</b> Teoría y técnica de la entrevista I y II, práctica supervisada de la entrevista, psicoterapia y consultoría de pareja.</li>
                            <li><b>Psicología clínica y salud mental:</b> Psicología clínica, Intervención en crisis I y II e integración de casos.</li>
                            <li><b>Psicología social y comunitaria:</b> Psicología social y comunitaria, psicoprevención.</li>
                            <li><b>Psicología educativa:</b> Psicología educativa y educación especial.</li>
                            <li>Psicología organizacional y laboral.</li>
                            <li><b>Psicología jurídica y forense:</b> Criminología.</li>
                            <li><b>Procesos psicológicos básicos:</b> Procesos psicológicos I y II.</li>
                            <li><b>Habilidades profesionales y Ética:</b> Introducción a la Psicología, Ética profesional, dinámica de grupos, teoría de la comunicación humana, sexualidad humana y Psicología recreativa.</li>
                            <li>Metodología de la investigación.</li>
                            <li><b>Antropología y filosofía:</b> Antropología filosófica.</li>
                            <li><b>Formación práctica y talleres:</b> Taller profesional I-V, seminario de desarrollo profesional I-V.</li>
                            <li><b>Psicología familiar:</b> Técnica de evaluación y diagnóstico familiar.</li>
                            <li><b>Formación complementaria:</b> Neuromotricidad.</li>
                            <li><b>Idiomas:</b> Inglés I, II, III, IV, V, VI, VII, VIII. Solo en modelo escolarizado.</li>
                        </ul>
                    </div>
                </div>
			</div>
		</div>
	</section>
    
    <section class="flex items-center justify-center mb-16 w-full">
		<div class="lg:flex flex-col lg:px-0 px-8 items-center w-full max-w-4xl lg:max-w-[1200px] justify-start">
			<div class="flex flex-col justify-between w-full">
				<div class="lg:flex items-center justify-center">
                    <div class="lg:w-[50%] text-justify mb-8 lg:mb-0 lg:mr-12">
                        <h2>
                            <span class="block leading-none text-left text-[28px]" style="">Cinco razones para elegir</span>
                            <span class="sr-only whitespace-nowrap">&nbsp;</span>
                            <span class="block text-hgold text-left font-serif mb-3 text-[42px]">Universidad Humanitas:</span>
                        </h2>
                        <ul class="list-disc pl-5 mb-4">
                            <li>Modelo educativo especializado.</li>
                            <li>Excelencia académica.</li>
                            <li>Instalaciones de primer nivel.</li>
                            <li>Costos accesibles.</li>
                            <li>Acreditaciones reconocidas (SEP, ESR y GPTW).</li>
                        </ul>
                    </div>
                    <div class="flex items-center justify-center w-full lg:max-w-[520px]">
						<img src="/pagesImages/beneficios-estudiar-universidad-humanitas.webp" alt="Beneficios de estudiar en Universidad Humanitas" class="w-full lg:max-w-[520px]"/>
					</div>
                </div>
			</div>
		</div>
	</section>

    <PoliticaIA />
</template>

<style scoped>
</style>